import React from 'react';
import Helmet from 'react-helmet';

import config from 'config';
import styles from './BrowseHeader.module.scss';

const BrowseHeader = () => (
  <div>
    <Helmet
      title="Browse Freelancers | Twine"
      link={[
        {
          rel: 'canonical',
          href: config.baseUrl + '/browse',
        },
      ]}
    />

    <h1 className={styles.title}>Browse Freelancers</h1>
  </div>
);

export default BrowseHeader;
